import { render, staticRenderFns } from "./StatsPlugin.vue?vue&type=template&id=e3308752&scoped=true"
import script from "./StatsPlugin.vue?vue&type=script&lang=ts"
export * from "./StatsPlugin.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./StatsPlugin.vue?vue&type=style&index=0&id=e3308752&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "e3308752",
  null
  ,true
)

export default component.exports